import React from 'react';
import {Form, Textarea, List} from 'components';
import {useNamedSelector} from 'helpers';

export function Lifestyle() {
  return (
    <Form {...useNamedSelector('clarity.form', { name: 'lifestyle' })}>
      <List tiny-gutter>
        <List.Title>Do you frequently feel stressed-out and overwhelmed? When? Why?</List.Title>
        <Textarea single name="1" />
        <List.Title>Do you believe your life is well balanced?</List.Title>
        <Textarea single name="2" />
        <List.Title>If not, what is missing? Which part(s) of your life are neglected?</List.Title>
        <Textarea single name="3" />
        <List.Title>What is the price you are paying for not living a balanced lifestyle?</List.Title>
        <Textarea single name="4" />
        <List.Title>What do you do to rest, unwind, and re-charge (both your mind and your spirit)?</List.Title>
        <Textarea single name="5" />
        <List.Title>What else can you do relax, rejuvenate and add more fun and pleasure to your life?</List.Title>
        <Textarea single name="6" />
        <List.Title>How would you describe your desired or ideal lifestyle?</List.Title>
        <Textarea single name="7" />
        <List.Title>How can you adjust your daily and weekly schedule to loosen up and enjoy more of life?</List.Title>
        <Textarea single name="8" />
      </List>
    </Form>
  );
}
